
import { Component, Mixins, Watch, Emit, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { Department, DepartmentGroup } from "../../../../domain/department";
import { User } from "../../../../domain/user";
import { ProjectTeam } from "../../../../domain/projectTeam";
import { SelectorDialogMixin } from "../../../system/dialogs/mixins";
import { ISingleSelectableAsynchronously, ISingleSelectableConditionallyAsynchronously } from "../../../system/selectors";
import { DepartmentFeatureAccessibleMixin } from "../../../department/mixins";
import { ProfessionFeatureAccessibleMixin } from "../../../profession/mixins";
import { UserFilterParameter } from "../../filters";
import { IUserListSelectorDialogCondition, instanceOfIUserListSelectorDialogCondition } from "../IUserListSelectorDialogCondition";

@Component
export default class UserListSelectorDialogMixin extends Mixins(SelectorDialogMixin, DepartmentFeatureAccessibleMixin, ProfessionFeatureAccessibleMixin) implements ISingleSelectableAsynchronously<User>, ISingleSelectableConditionallyAsynchronously<User, IUserListSelectorDialogCondition> {
  get title(): string {
    return this.name + "選択";
  }

  data(): any {
    return {
      filter: new UserFilterParameter(),
      department: null,
      projectTeam: null,
      name: "職員",
      defaultSelectedProfessionCodes: null,
      shouldHideSelectLoginUserButton: false,
      shouldHideClearSelectionButton: false,
    };
  }
  filter: UserFilterParameter;
  department: Department;
  projectTeam: ProjectTeam;
  name: string;
  defaultSelectedProfessionCodes: string[];
  shouldHideSelectLoginUserButton: boolean;
  shouldHideClearSelectionButton: boolean;

  @Prop()
  departmentGroup: DepartmentGroup;
  
  get appliedFilter(): (source: User) => boolean {
    return s => this.filter.filter(s);
  }

  get selectedUser(): User {
    return this.selected;
  }

  @Watch("department")
  onDepartmentChanged(newValue: Department, oldValue: Department): void {
    this.departmentChanged(newValue);
  }

  @Emit()
  departmentChanged(changed: Department): void {}

  async selectOption(defaultOption?: User): Promise<User> {
    return this.show<User>(defaultOption);
  }

  async selectOptionConditionally(condition: IUserListSelectorDialogCondition, defaultOption?: User): Promise<User> {
    if (!this.isDepartmentFeatureEnable) { return this.show<User>(defaultOption); }
    this.department = (condition && condition.departmentId)
      ? await DomainRegistry.department.getDepartmentRepository().getEntity(condition.departmentId)
      : null;
    if (instanceOfIUserListSelectorDialogCondition(condition)) {
      this.name = condition.name ? condition.name : "職員";
      this.defaultSelectedProfessionCodes = condition.defaultSelectedProfessionCodes;
    }
    this.shouldHideSelectLoginUserButton = !!condition && !!condition.shouldHideSelectLoginUserButton;
    this.shouldHideClearSelectionButton = !!condition && !!condition.shouldHideClearSelectionButton;
    return this.show<User>(defaultOption);
  }

  selectLoginUser(): void {
    this.select(this.$store.getters.user);
  }

  get shouldShowProjectTeamSelector(): boolean {
    return this.$configuration.behavior.user.finder.shouldShowProjectTeamSelector;
  }

  get shouldShowBelongedAllDepartmentsSelector(): boolean {
    return this.$configuration.behavior.user.finder.shouldShowBelongedAllDepartmentsSelector;
  }
}
